"use client";

import { c as _c } from "react/compiler-runtime";
import { useTheme } from "next-themes";
import type * as React from "react";
import { Toaster as Sonner, type ToasterProps, toast } from "sonner";

/**
 * Where toasts appear. Mount it once near the root of the app, then call
 * `toast()` from anywhere.
 */
function Toaster(props) {
  const $ = _c(5);
  const {
    resolvedTheme
  } = useTheme();
  const t0 = resolvedTheme === "dark" ? "dark" : "light";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      "--normal-bg": "var(--card)",
      "--normal-text": "var(--foreground)",
      "--normal-border": "var(--border)",
      "--border-radius": "var(--radius-md)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      classNames: {
        toast: "body-md shadow-lg",
        description: "body-sm text-muted-foreground"
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== props || $[3] !== t0) {
    t3 = <Sonner theme={t0} style={t1 as React.CSSProperties} toastOptions={t2} {...props} />;
    $[2] = props;
    $[3] = t0;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export { Toaster, type ToasterProps, toast };